import ReactRenderer from './react/ReactRenderer'
import ProjectsArchive from './react/projects-archive/ProjectsArchive'

window.addEventListener('load', () => {
  ReactRenderer.registerComponent(ProjectsArchive, 'ProjectsArchive')

  ReactRenderer.render()
})
